module.exports = __webpack_public_path__ + "static/media/avatar_placeholder.afd945dc.png";